<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-behavior" title="Add New Behavior" v-if="showButton" v-on:click="openBehaviorModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <b-modal v-model="openBehaviorModel" title="New Behavior" size="lg" ok-title="Create Behavior" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="behaviorModal" :no-close-on-backdrop="true" scrollable>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.behavior_name }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.behavior_name}">
                    Behavior Name: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="behavior_name" v-model="behavior.behavior_name" :class="{'form-control': true, 'is-invalid': errors.behavior_name}" placeholder="Enter Behavior Name" />
                    <span v-if="errors.behavior_name" class="text-danger">
                        <span v-for="error in errors.behavior_name">{{ error }}</span>
                    </span>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
        },

        data: function() {
            return {
                loading: true,
                behavior: {},
                openBehaviorModel: false,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            show(){
                this.openBehaviorModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.behavior = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveBehavior();
            },

            saveBehavior() {
                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/behavior', this.behavior)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Behavior Saved');

                    //Close the modal
                    this.$refs.behaviorModal.hide();

                    //Return to main list?
                    this.$emit('behaviorCreated', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    this.$emit('behaviorFailed', null);
                })
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.behaviorModal.$refs);
            //this.$refs.behaviorModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>

<style scoped>
    .new-behavior {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>